export default __webpack_public_path__ + "static/media/tele.545aab68.png";